module.exports = __webpack_public_path__ + "img/car-style_pop.3da0ba5a.svg";